export default "__VITE_ASSET__BXTJNuaZ__"